import { Box, Button, Typography } from "@mui/material";
import { use100vh } from "react-div-100vh";
import { useOnlineStatus } from "../hooks/use-online-status";
import { useTranslation } from "react-i18next";

export const ErrorInfo = () => {
  const isOnline = useOnlineStatus();
  const { t } = useTranslation("common");

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: `${use100vh()}px` }}>
      <Box
        sx={{
          width: "500px",
          height: "auto",
          padding: "20px",
          textAlign: "center"
        }}
      >
        <Typography variant="h3">{isOnline ? t("technicalIssues") : t("youAreOffline")}</Typography>
        <Typography variant="h5">
          {isOnline ? t("clickButtonToResolve") : t("backOnlineClickReload")}
        </Typography>

        <Button
          sx={{
            margin: 1
          }}
          variant="outlined"
          onClick={() => {
            location.reload();
          }}
        >
          {t("reload")}
        </Button>

        <Typography variant="h5">{t("restartAppIfIssuePersists")}</Typography>
      </Box>
    </Box>
  );
};

export default ErrorInfo;
